module.exports = __webpack_public_path__ + "img/resultsuccess.452806ff.svg";